

export default class MessageType {
  static TXT = 1; //文本
  static VOICE = 2; //语音
  static VIDEO = 3; //视频
  static IMAGE = 4; //图片
  static REDBAG = 5; //红包
  static SHARE_LINK = 6; //链接
  static CARD = 7; //名片
  static GET_REDBAG = 8; //领取红包
  static TRANSFER_ACCOUNTS = 10; //转账消息
  static CARD_GROUP = 11; //群名片
  static RECALL = 12; //撤回消息
  static CONFIRM_ORDER = 13; //确认订单
  static SERVER_TXT = 14; //server模拟发送信息类型
  static FILE = 15; //文件类型
  static AT = 16; //@
  static MONEY_LOG = 17; //支付号消息
  static PROGRAME = 18; //小程序
  static COMING = 999; //xxxx进来了直播间

  static VOICE_CHAT = 100; //极光实时语音
  static VOICE_CHAT_PACKAT = 101; //实时语音包
  static VOICE_CHAT1 = 102; //声网实时语音

  static CENTER_TIP = 10000; //提示
  static CENTER_TIP_CONFIRM = 10001; //群申请提示
  static CENTER_TIP_CONFIRM1 = 10002; //群申请确认
  static CENTER_TIP_NEED_VERFY = 10003; //对方不是好友
  static CENTER_TIP_QRCODE = 10004; //扫描二维码加群
  static CENTER_TIP_MONEY = 10005; //支付消息
  static CENTER_TIP_SCREENSHOT = 10006; //截屏提醒
  static CENTER_TIP_SNAP = 10007; //阅后即焚
  static CENTER_TIP_SCREENSHOT_OPEN = 10008; //开启截屏提醒
  static CENTER_TIP_ORDER = 10009; //订单操作气泡
  static CENTER_TIP_TRANSFRT = 10010; //聊天界面转账----->通知
  static CENTER_TIP_GROUP_CODE = 10011; //邀请链接加群
  static checkIsSupport = msgtype => {
    if (msgtype == MessageType.VOICE_CHAT || MessageType.VOICE_CHAT1) {
      return true;
    }
    if (msgtype >= 0 && msgtype <= MessageType.PROGRAME) {
      return true;
    }
    if (
      msgtype >= MessageType.CENTER_TIP &&
      msgtype <= MessageType.CENTER_TIP_TRANSFRT
    ) {
      return true;
    }
    return false;
  };

  //是否可删除
  static isCanDelete(msgtype) {
    if (msgtype >= MessageType.CENTER_TIP) {
      return false;
    }
    if (msgtype == MessageType.GET_REDBAG) {
      return false;
    }
    if (msgtype == MessageType.RECALL) {
      return false;
    }
    if (msgtype == MessageType.CENTER_TIP_ORDER) {
      return false;
    }

    return true;
  }

  static isPlaySound(msgtype) {
    if (msgtype < 10000 && msgtype != MessageType.RECALL && msgtype != MessageType.SERVER_TXT) {
      //playSound
    }
  }

  //是否本地发送
  static isLocalSend(msgtype) {
    return (msgtype == MessageType.TXT ||
      msgtype == MessageType.VOICE ||
      msgtype == MessageType.IMAGE ||
      msgtype == MessageType.VIDEO ||
      msgtype == MessageType.FILE ||
      msgtype == MessageType.AT);
  }

  /**
   * 检测是否正常消息,非提示类消息
   * @param {} msgtype
   */
  static checkNormalMsg(msgtype) {
    return (
      msgtype === MessageType.TXT ||
      msgtype === MessageType.VOICE ||
      msgtype === MessageType.IMAGE ||
      msgtype === MessageType.VIDEO ||
      msgtype === MessageType.REDBAG ||
      msgtype === MessageType.SHARE_LINK ||
      msgtype === MessageType.CARD ||
      msgtype === MessageType.VOICE_CHAT ||
      msgtype === MessageType.VOICE_CHAT1 ||
      msgtype === MessageType.CENTER_TIP_NEED_VERFY ||
      msgtype === MessageType.CENTER_TIP_QRCODE ||
      msgtype === MessageType.CARD_GROUP ||
      msgtype == MessageType.FILE ||
      msgtype == MessageType.AT ||
      msgtype == MessageType.CENTER_TIP_SCREENSHOT ||
      msgtype == MessageType.MONEY_LOG ||
      msgtype == MessageType.CENTER_TIP_ORDER ||
      msgtype == MessageType.TRANSFER_ACCOUNTS ||
      msgtype == MessageType.CENTER_TIP_TRANSFRT ||
      msgtype == MessageType.PROGRAME ||
      msgtype === MessageType.CENTER_TIP_GROUP_CODE
    );
  }

  /**
   * 是否有需要已读标识
   * @param {*} msgtype
   */
  static checkIsCanRead(msgtype) {
    return (
      msgtype == MessageType.TXT ||
      msgtype == MessageType.IMAGE ||
      msgtype == MessageType.SHARE_LINK ||
      msgtype == MessageType.CARD ||
      msgtype == MessageType.CARD_GROUP ||
      msgtype == MessageType.VOICE ||
      msgtype == MessageType.VIDEO ||
      msgtype == MessageType.FILE ||
      msgtype == MessageType.AT ||
      msgtype == MessageType.TRANSFER_ACCOUNTS ||
      msgtype == MessageType.PROGRAME
    );
  }

  static checkFile(msgtype) {
    return (
      msgtype == MessageType.IMAGE ||
      msgtype == MessageType.VIDEO ||
      msgtype == MessageType.VOICE ||
      msgtype == MessageType.FILE
    );
  }
}

/*
const icons = [
  require('../images/im/icon_gs_0.png'),
  require('../images/im/icon_gs_1.png'),
  require('../images/im/icon_gs_2.png'),
  require('../images/im/icon_gs_3.png'),
  require('../images/im/icon_gs_4.png'),
  require('../images/im/icon_gs_5.png'),
  require('../images/im/icon_gs_6.png'),
  require('../images/im/icon_gs_7.png'),
];
export class FileType {
  static OTHER = 0;
  static TXT = 1;
  static EXCEL = 2;
  static PDF = 3;
  static PPT = 4;
  static ZIP = 5;
  static DOC = 6;
  static IMAGE = 7;
  static VIDEO = 8;

  static getFileType(filename = '') {
    let type = FileType.OTHER;
    if (filename.endsWith('txt')) {
      type = FileType.TXT;
    }
    if (filename.endsWith('xls')) {
      type = FileType.EXCEL;
    }
    if (filename.endsWith('pdf')) {
      type = FileType.PDF;
    }
    if (filename.endsWith('zip') || filename.endsWith('rar')) {
      type = FileType.ZIP;
    }
    if (filename.endsWith('doc') || filename.endsWith('docx')) {
      type = FileType.DOC;
    }
    if (
      filename.endsWith('jpg') ||
      filename.endsWith('png') ||
      filename.endsWith('jpeg')
    ) {
      type = FileType.IMAGE;
    }
    if (filename.endsWith('mp4') || filename.endsWith('mov')) {
      type = FileType.VIDEO;
    }
    // console.log('type---->', type);
    return { type: type, icon: icons[type] };
  }
}*/
